import { useEffect, useState } from 'react';
import { Icons, SmartFormEmbed } from '@amo/core/components/containers';

const CancelPaiement = (props) => {
    const {
        marque,
        modele,
        immatriculation,
        formule,
        previousStep,
        payEmbeddedData,
        payEmbeddedLoading,
        postPayEmbeddedSubmit,
        goToValidation,
    } = props;

    const [smartFormError, setSmartFormError] = useState(null);

    useEffect(() => {
        if (!payEmbeddedData && !payEmbeddedLoading) {
            postPayEmbeddedSubmit();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div>
            <div className={'bg-secondary-light p-4 mb-5 text-center rounded'}>
                <div className={'f-21 text-primary-light mb-3'}>
                    <Icons className={`d-inline-block position-relative me-2`} fontSize={30} icon={'triangle'} />
                    Votre souscription est en attente de paiement.
                </div>

                <div className={'f-21 mb-3'}>
                    Vous êtes à deux pas de finaliser la souscription
                    <br />
                    pour votre{' '}
                    <b>
                        {marque} {modele}
                    </b>{' '}
                    immatriculé <b>{immatriculation}</b> avec la formule <b>{formule}</b>&nbsp;!
                </div>

                <div className={'f-18'}>Un espace de paiement sécurisé plus rapide et sécurisée&nbsp;!</div>
            </div>

            {/* Krypton affiche ses propres erreurs de validation (CLIENT_xxx)
                en interne — pas besoin de doublon React. On garde onError
                pour le tracking côté analytics au cas où. */}
            {payEmbeddedData ? (
                <SmartFormEmbed
                    formToken={payEmbeddedData.formToken}
                    publicKey={payEmbeddedData.publicKey}
                    endpoint={payEmbeddedData.endpoint}
                    onPaid={goToValidation}
                    onError={setSmartFormError}
                />
            ) : (
                <div className={'text-center py-5'}>
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Chargement du paiement sécurisé...</span>
                    </div>
                </div>
            )}

            <div className={'submit-row mt-4'}>
                <button className={`btn btn-outline-primary medium-rounded`} onClick={() => previousStep()}>
                    Retour
                </button>
            </div>
        </div>
    );
};

export default CancelPaiement;
